import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetosambhajinagartaxifare() {



const cardData = {
  keyword: " Pune to Sambhaji Nagar Taxi fare ",

"headingDescription": "SRS Cab Service offers Pune to Sambhaji Nagar Taxi, providing a comfortable, safe, and reliable travel solution for pilgrims, families, and corporate travelers. Our professional drivers, well-maintained vehicles, and timely pickups ensure a smooth and hassle-free journey from Pune to Sambhaji Nagar. Ideal for sightseeing, city tours, and group travel, SRS Cab Service delivers flexible booking options, transparent pricing, and 24/7 customer support for a convenient and enjoyable journey.",
"topPlaces": [
  {
    "title": "Sambhaji Nagar Fort",
    "description": "Sambhaji Nagar Fort is a historic landmark known for its architectural significance and Maratha history. Travelers using SRS Cab Service from Pune often visit this fort to explore the region’s heritage and scenic views."
  },
  {
    "title": "Ellora Caves",
    "description": "Ellora Caves are a UNESCO World Heritage site with ancient rock-cut temples and monasteries. Visitors using SRS Cab Service often include this site in their itinerary to admire the remarkable sculptures and historical significance."
  },
  {
    "title": "Grishneshwar Jyotirlinga Temple",
    "description": "Grishneshwar Temple is a sacred Jyotirlinga of Lord Shiva near Sambhaji Nagar. Travelers using SRS Cab Service often stop here for prayers and spiritual rituals during their journey."
  },
  {
    "title": "Aurangabad Caves",
    "description": "Aurangabad Caves are ancient Buddhist rock-cut structures offering rich history and scenic views. Visitors traveling with SRS Cab Service often explore these caves for cultural and historical insights."
  },
  {
    "title": "Bibi Ka Maqbara",
    "description": "Bibi Ka Maqbara is an iconic Mughal-era monument often called the 'Taj of the Deccan'. Travelers using SRS Cab Service from Pune frequently visit this landmark for its architectural beauty and photography."
  },
  {
    "title": "Daulatabad Fort",
    "description": "Daulatabad Fort is a historically significant hill fort near Sambhaji Nagar. Visitors using SRS Cab Service often include this site to experience its impressive defensive structures and panoramic views."
  },
  {
    "title": "Panchakki",
    "description": "Panchakki is an ancient water mill and heritage site in Sambhaji Nagar. Travelers using SRS Cab Service often explore this attraction for its engineering marvel and cultural value."
  },
  {
    "title": "Salim Ali Lake",
    "description": "Salim Ali Lake is a serene natural spot perfect for relaxation and bird watching. Visitors using SRS Cab Service often stop here for leisure and photography."
  },
  {
    "title": "Jayakwadi Dam",
    "description": "Jayakwadi Dam is a scenic spot near Sambhaji Nagar ideal for nature lovers and picnics. Travelers using SRS Cab Service often include this site for a peaceful break during their journey."
  },
  {
    "title": "Chand Minar",
    "description": "Chand Minar is a historic tower known for its intricate design and panoramic views. Visitors using SRS Cab Service from Pune often visit this landmark to learn about the region’s history and architecture."
  }
],



services: [
{
name: "Pune to Sambhaji Nagar Taxi Fare",
description: "Pune to Sambhaji Nagar taxi fare provides detailed pricing for travel planning. Customers can check fare estimates before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with taxi fare services."
},
{
name: "Pune to Sambhaji Nagar Cab Charges",
description: "Pune to Sambhaji Nagar cab charges offer clear pricing for travelers. Customers can check charges before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose cab services with transparent charges."
},
{
name: "Pune to Sambhaji Nagar Taxi Booking",
description: "Pune to Sambhaji Nagar taxi booking provides quick and easy reservation options. Customers can book taxis online or offline. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your taxi easily from Pune."
},
{
name: "Pune to Sambhaji Nagar Car Rental",
description: "Pune to Sambhaji Nagar car rental offers flexible vehicle options for long-distance travel. Customers can rent cars for family and business trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Rent cars easily from Pune."
},
{
name: "Pune to Sambhaji Nagar Taxi Rates",
description: "Pune to Sambhaji Nagar taxi rates provide clear pricing details for travelers. Customers can compare rates before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose taxi services with transparent rates."
},
{
name: "Pune to Sambhaji Nagar Cab Pricing",
description: "Pune to Sambhaji Nagar cab pricing offers detailed cost breakdown for trips. Customers can compare pricing before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose cab services with transparent pricing."
},
{
name: "Pune to Sambhaji Nagar Private Car Hire",
description: "Pune to Sambhaji Nagar private car hire offers personalized travel for families and groups. Customers can hire vehicles for flexible journeys. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with private car hire services."
},
{
name: "Pune to Sambhaji Nagar Cab Cost",
description: "Pune to Sambhaji Nagar cab cost provides estimated pricing for travelers. Customers can check trip cost before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with cab cost services."
},
{
name: "Pune to Sambhaji Nagar Taxi Service Charges",
description: "Pune to Sambhaji Nagar taxi service charges offer clear pricing for transportation. Customers can check charges before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose taxi services with transparent charges."
},
{
name: "Pune to Sambhaji Nagar Travel Fare",
description: "Pune to Sambhaji Nagar travel fare provides estimated pricing for long-distance trips. Customers can compare fares before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with fare services."
},
{
name: "Pune to Sambhaji Nagar Cab Booking Online",
description: "Pune to Sambhaji Nagar cab booking online offers instant reservation options. Customers can book cabs digitally with ease. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab online easily."
},
{
name: "Pune to Sambhaji Nagar One-Way Taxi Fare",
description: "Pune to Sambhaji Nagar one-way taxi fare provides economical travel options without return charges. Customers can check fares before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with one-way taxi services."
},
{
name: "Pune to Aurangabad Cab",
description: "Pune to Aurangabad cab offers reliable transportation for intercity travel. Customers can book cabs for business and leisure trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily from Pune to Aurangabad."
},
{
name: "Pune to Aurangabad Taxi",
description: "Pune to Aurangabad taxi provides convenient travel for long-distance journeys. Customers can book taxis for flexible travel plans. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with taxi services."
},
{
name: "Pune to Aurangabad Taxi Fare",
description: "Pune to Aurangabad taxi fare provides detailed pricing for travel planning. Customers can compare fares before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with taxi fare services."
},
{
name: "Pune to Aurangabad Cab One Way",
description: "Pune to Aurangabad cab one way offers economical travel for direct journeys. Customers can book cabs without return charges. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Choose one-way cab services easily."
},
{
name: "Pune to Aurangabad Daily Taxi",
description: "Pune to Aurangabad daily taxi provides regular travel options for frequent passengers. Customers can book taxis for daily or repeated trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with daily taxi services."
},
{
name: "Pune to Aurangabad Taxi Drop",
description: "Pune to Aurangabad taxi drop offers direct one-way transportation services. Customers can book taxis for convenient drop journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Choose taxi drop services from Pune."
}
],

tableData: [
["Pune to Sambhaji Nagar Taxi Fare","Pune to Sambhaji Nagar Cab Charges"],
["Pune to Sambhaji Nagar Taxi Booking","Pune to Sambhaji Nagar Car Rental"],
["Pune to Sambhaji Nagar Taxi Rates","Pune to Sambhaji Nagar Cab Pricing"],
["Pune to Sambhaji Nagar Private Car Hire","Pune to Sambhaji Nagar Cab Cost"],
["Pune to Sambhaji Nagar Taxi Service Charges","Pune to Sambhaji Nagar Travel Fare"],
["Pune to Sambhaji Nagar Cab Booking Online","Pune to Sambhaji Nagar One-Way Taxi Fare"],
["Pune to Aurangabad Cab","Pune to Aurangabad Taxi"],
["Pune to Aurangabad Taxi Fare","Pune to Aurangabad Cab One Way"],
["Pune to Aurangabad Daily Taxi","Pune to Aurangabad Taxi Drop"]
],



whychoose: [
  {
    WhyChooseheading: "Affordable Pune to Sambhaji Nagar Taxi Fare",
    WhyChoosedescription: "SRS Cab Service offers competitive Pune to Sambhaji Nagar taxi fare starting from budget-friendly rates, making it suitable for both one-way and round-trip travel."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "We provide clear fare breakdown including tolls, driver allowance, and taxes so customers know the exact cost before booking their Pune to Sambhaji Nagar taxi."
  },
  {
    WhyChooseheading: "Best Per KM Fare Options",
    WhyChoosedescription: "Pune to Sambhaji Nagar taxi fare is calculated on per km basis, generally starting from ₹10 to ₹14 per km depending on vehicle type and travel plan."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Fare",
    WhyChoosedescription: "We offer flexible fare options including one-way drop, round trip packages, and customized pricing based on your travel needs."
  },
  {
    WhyChooseheading: "Multiple Cab Options at Different Prices",
    WhyChoosedescription: "Choose from hatchback, sedan, SUV, and Innova Crysta with different fare ranges suitable for budget and premium travel."
  },
  {
    WhyChooseheading: "24/7 Cab Service at Fixed Pricing",
    WhyChoosedescription: "SRS Cab Service provides reliable Pune to Sambhaji Nagar taxi service at any time with consistent and fair pricing without surge charges."
  },
  {
    WhyChooseheading: "All-Inclusive Fare Packages Available",
    WhyChoosedescription: "We provide all-inclusive taxi fare options covering fuel, tolls, and driver charges for hassle-free travel."
  },
  {
    WhyChooseheading: "Trusted & Cost-Effective Taxi Service",
    WhyChoosedescription: "SRS Cab Service is trusted for offering fair Pune to Sambhaji Nagar taxi fare with reliable service and comfortable travel experience."
  }
]
}

const faqData = [
  { question: "What is the taxi fare from Pune to Sambhaji Nagar?", answer: "The taxi fare typically starts from around ₹2200 to ₹3000 for one-way sedan and can go up to ₹5000–₹7500 depending on vehicle type and service. :contentReference[oaicite:0]{index=0}" },
  { question: "What is the per km rate for Pune to Sambhaji Nagar taxi?", answer: "The per km taxi rate usually starts from ₹10 to ₹14 per km depending on the vehicle and provider. :contentReference[oaicite:1]{index=1}" },
  { question: "How far is Sambhaji Nagar from Pune?", answer: "The distance between Pune and Sambhaji Nagar (Aurangabad) is approximately 230 km and takes around 4 to 5 hours." },
  { question: "Which cab is cheapest for this route?", answer: "Hatchback and sedan cars are the cheapest options, with fares starting from around ₹2200–₹3000 for one-way trips. :contentReference[oaicite:2]{index=2}" },
  { question: "What is the SUV or Innova fare for this route?", answer: "SUV fares like Innova typically range from ₹4000 to ₹6000 depending on travel type and availability. :contentReference[oaicite:3]{index=3}" },
  { question: "Are tolls included in the fare?", answer: "Toll charges may be included in package fares or added separately depending on the service provider." },
  { question: "Is one-way taxi available for Pune to Sambhaji Nagar?", answer: "Yes, one-way cab services are available and are usually cheaper than round-trip bookings." },
  { question: "Do prices change based on time or demand?", answer: "Yes, taxi fares may vary based on demand, season, vehicle type, and travel time." },
  { question: "Can I book taxi online for this route?", answer: "Yes, you can easily book Pune to Sambhaji Nagar taxi online or via phone booking." },
  { question: "Is round trip cheaper than one-way?", answer: "Round trips may be more economical for multi-day travel, while one-way is cheaper for single-side journeys." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ashok Patil",
    feedback:
      "Booked Pune to Sambhaji Nagar cab with SRS. Fare was reasonable and no hidden charges.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Kavita Deshmukh",
    feedback:
      "Very affordable taxi fare and smooth journey. Best option for Pune to Aurangabad travel.",
    rating: 5
  }
];






























const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];














const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Sambhaji Nagar Taxi Fare | SRS Cab",
  "description": "SRS Cab provides Pune to Sambhaji Nagar (Aurangabad) taxi services with affordable cab charges, fare estimates, and online booking. Book one-way or round trip taxis, car rentals, and private car hire for safe, comfortable, and reliable travel with 24x7 service.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};




  return (
    <div>
      
<Helmet>
  <title>Pune to Sambhaji Nagar Taxi Fare | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Check Pune to Sambhaji Nagar taxi fare with SRS Cab. Affordable cab charges, one-way and round trip taxi booking, car rentals, and private car hire from Pune to Aurangabad. 24x7 online booking with safe and comfortable rides." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/40.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetosambhajinagartaxifare;